import { dataSelector } from '@nextiva/global-store';
import { useMutation } from 'react-query';
import { useSelector } from 'react-redux';

import { policyDecisionRequestsPayloadType } from 'types/purchaseLicenseModalTypes';

import { postPolicyDecisionGrantRequest } from 'services/policyDecisionRequests/policyDecisionRequestService';
import { GlobalStoreInterface } from 'interface/globalStore';

export const usePostPolicyDecisionGrantRequest = () => {
  const globalStoreData: GlobalStoreInterface | undefined = useSelector(
    dataSelector,
  );
  const sso: string = globalStoreData?.sso;
  const corpAccountNumber: string =
    globalStoreData?.user?.accountInfo?.corpAcctNbr ??
    globalStoreData?.user?.profileDTO?.corpAcctNbr;

  return useMutation((payload: policyDecisionRequestsPayloadType) =>
    postPolicyDecisionGrantRequest(corpAccountNumber, sso, payload),
  );
};
